module.exports = __webpack_public_path__ + "img/text_charactor.1ad3de09.png";